import getText from 'AppUtils/language';
import React from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';


import iconClose from '../header/main/img/icon-close.png';

import './Menu.scss';
import './ModalLanguage.scss';

Modal.setAppElement('#root')

const MenuComponent = (props) => {

	const renderLanguages = () => {
		if(props.appGetConfig && props.appGetConfig.config && props.appGetConfig.config.i18n) {
			return Object.keys(props.appGetConfig.config.i18n.languages).map((language, i) => (
				<div className="custom-radio" key={language}>
					<input
						type="radio"
						id={language}
						name="radio-group"
						value={language}
						checked={props.currentLanguage === language}
						onChange={(e) => props.handleChangeLanguage(e)}
					/>
					<label htmlFor={language}>({language}) {props.appGetConfig.config.i18n.languages[language]}</label>
				</div>
			))
		}
	};

	const renderMenuItems = () => {
		let menuItems = [];
		props.menuItems.map((item, i) => {
			if((item.link === '/logout' || item.link === '/unsubscribe') && props.authStatus === 'guest') {

			} else {
				menuItems.push(
					<li className={(item.restricted && props.authStatus === 'restricted' && item.link !== '/logout' && item.link !== '/profile') || (item.restricted && !props.authIsAuthenticated) ? 'restricted' : ''} key={i}>
						<Link target={item.externalLink ? '_blank' : '_self'} to={{pathname: item.externalLink ?? item.link}} onClick={item.callback ? (e) => {
								e.preventDefault();
								props.toggleMenu();
								setTimeout(() =>props.openModal(), 300);
							}
							: item.restricted && !props.authIsAuthenticated ? (e) => {
									e.preventDefault();
								}
								: item.link === '/logout' ? (e) => {
										e.preventDefault();
										props.uiRedirect({
											pathname: '/'
										})
										props.authLogout();
										props.toggleMenu();
									}
									: (item.link === '/unsubscribe' && !item.externalLink) ? (e) => {
											e.preventDefault();
											props.toggleMenu();

											props.uiRedirect({
												pathname: '/unsubscribe'
											});

											// if (!props.authenticationNotManual) {
											// 	props.uiRedirect({
											// 		pathname: '/unsubscribe'
											// 	})
											// } else {
											// 	props.openGeneralModal('', getText('unsubscribe[text_confirm]'), true, getText('unsubscribe[button_yes]'),() => {
											// 		props.userLoadUnsubscribe();
											// 	});
											// }
										}
										: () => {
											props.toggleMenu();
										}}>
							{item.text}
						</Link>
					</li>
				)
			}
		})

		return menuItems;
	}

	return (
		<>
			<Modal
				isOpen={props.modalIsOpen}
				onRequestClose={props.closeModal}
				contentLabel="Example Modal"
				className="modal-language"
			>
				<div className="languages-container">
					<button className="close-modal" onClick={props.closeModal}><img src={iconClose} alt=""/></button>
					<h2>{getText("languages[text_title]")}</h2>
					<div className="language-content">
						<form action="">
							{renderLanguages()}
						</form>
					</div>
				</div>
			</Modal>
			<nav className={props.menuIsOpen ? 'active' : ''}>
				<div className="nav-inner">
					<ul>
						{ renderMenuItems() }
					</ul>
				</div>
			</nav>
		</>
	);
}

export default MenuComponent;
